// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uploadedPic {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  height: 100%;
  position: relative;
  margin-right: 15px;
  height: 60px;
  /* flex-direction: row; */
  flex-wrap: wrap;
  overflow: hidden;
  overflow-y: auto;
}

.uploadedPic .btnDelete {
  position: relative;
}

a.hyperlink {
  width: 60%;
  margin-bottom: 0px;
}`, "",{"version":3,"sources":["webpack://./src/app/agent/agent-document-image/agent-document-image.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,WAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AACF;;AACA;EACE,kBAAA;AAEF;;AAEA;EACE,UAAA;EACA,kBAAA;AACF","sourcesContent":[".uploadedPic {\r\n  display: flex;\r\n  width: 100%;\r\n  align-items: center;\r\n  justify-content: center;\r\n  height: 100%;\r\n  position: relative;\r\n  margin-right: 15px;\r\n  height: 60px;\r\n  /* flex-direction: row; */\r\n  flex-wrap: wrap;\r\n  overflow: hidden;\r\n  overflow-y: auto;\r\n}\r\n.uploadedPic .btnDelete {\r\n  position: relative;\r\n  //   left: 100%;\r\n}\r\n\r\na.hyperlink {\r\n  width: 60%;\r\n  margin-bottom: 0px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
